import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {getCookie, removeCookie} from "react-use-cookie";

import {setNavigateFunction} from "../../api/apiSetup";
import {setNotAuth} from "../../slices/UserSlice";
import {findIfTokenExpired} from "../../utilities/generalConstants.js/generalConstants";
import {toaster} from "../../utilities/hooks/toaster";

const TokenControl = () => {
  const isTokenExpired = findIfTokenExpired();
  const dispatch = useDispatch();
  const token = getCookie("access_token");

  //for axios.hook to navigate to /login if isTokenExpired
  const navigate = useNavigate();
  const location = useLocation();
  const locationPath = location.pathname;

  useEffect(() => {
    setNavigateFunction(navigate);
  }, [navigate]);

  useEffect(() => {
    if (token && !isTokenExpired) return;

    dispatch(setNotAuth());
    toaster.error("Session has expired. Please log in again.", 3000);
    locationPath !== "/login" && navigate("/login", {state: {from: locationPath}});
    removeCookie("access_token");
    localStorage.removeItem("login_time");
  }, [isTokenExpired, token]);

  return <></>;
};

export default TokenControl;
